module.exports = __webpack_public_path__ + "images/8fa9aba7b7df2d7c0fae846946a3f69a.svg";